@if (opts.queryExtras) {
    <ngxh6-crud [opts]="opts" [templateRef]="table"></ngxh6-crud>
}

<ng-template #table let-response="response" let-crud="crud">
    <div class="table-responsive-lg">
        <table class="table table-hover">
            <tr>
                <th>Date</th>
                <th>Activity</th>
            </tr>
            @if (response) {
                <tbody>
                    @for (item of r(response).data; track item; let i = $index) {
                        <ng-container class="mb-4">
                            <tr>
                                <td class="align-middle" style="min-width: 50px">
                                    {{ item.activity.date | str2Date | date: 'EEE - d MMM yyyy' }} {{ item.activity.startTime | str2Date | date: 'hh:mm a' }}
                                </td>
                                <td class="align-middle" style="min-width: 110px">
                                    <a [routerLink]="'/macyouth/activities/' + item.activity.id">{{ item.activity.fullLabel }}</a>
                                </td>
                            </tr>
                        </ng-container>
                    }
                </tbody>
            }
        </table>
    </div>
    @if (response && !response.data.length) {
        <small class="my-4 text-muted">No Staff Attendances to show.</small>
    }
</ng-template>
